// extracted by mini-css-extract-plugin
export var feedbackForm = "FeedbackBtn-module--feedbackForm--ffVBb";